export default "__VITE_ASSET__I57CfCCg__"